module.exports = __webpack_public_path__ + "img/bar.7aa6a322.png";